import {ErrorMessage} from "formik";

const CustomErrorMessage = ({name}) => {
    return <ErrorMessage component="span" className="validation-error" name={name}/>
}

export default CustomErrorMessage;